import { Map } from 'immutable';
import _ from 'lodash';

import PlusBus, { options } from '../PlusBus';
import Fare from './Fare.js';
import { resolve } from '../../helpers/LinkMapper';

function makePortionFares (portion) {
    if (!portion) { return null; }

    return new Map({
        origin: resolve(portion.origin).as(Fare),
        destination: resolve(portion.destination).as(Fare)
    });
}

class OrderPlusBus extends PlusBus {

    static fromJSON (json = null) {

        // NOTE: Reserved naming issues may arise by using "return"
        const outward = resolve(json.outward).with(makePortionFares);
        const inward = resolve(json.return).with(makePortionFares);

        let result = { outward, return: inward };

        return new OrderPlusBus(result);
    }

    getTotalPrice () {
        return _.reduce(options, (total, option) => {
            const terminal = this.getTerminal.apply(this, option);
            if (terminal) {
                return total + terminal.getTotalPrice();
            }
            return total;
        }, 0);
    }

    matchesOriginOrDestination (fare, direction) {
        const matches = _.compact(["origin", "destination"].map((val) => {
            const portion = this.getPortion(direction);
            if (!portion) {
                return false;
            }

            const plusBus = portion.get(val);
            if (!plusBus) {
                return false;
            }

            return plusBus.destination.equals(fare.destination) && plusBus.origin.equals(fare.origin);
        }));

        return matches.length >= 1;
    }


}

export default OrderPlusBus;
